import React from 'react'
import { format } from 'date-fns'
import { FaCloudArrowUp } from 'react-icons/fa6'

import { useMessageProperties } from '../message-provider'
import IconWithTooltip from '~components/shared/icons/icon-with-tooltip'

export default function WrittenBackIndicator() {
    const { message } = useMessageProperties()

    if (!message.written_back_at) return null

    return (
        <IconWithTooltip
            icon={FaCloudArrowUp}
            color="blackAlpha.500"
            fontSize="14px"
            label={`Written back on ${format(message.written_back_at || Date.now(), 'PPpp')}`}
            tooltipOverrides={{
                bg: 'white',
                borderColor: 'blackAlpha.200',
                borderWidth: 1,
                fontSize: '12px',
                color: 'gray.700',
            }}
        />
    )
}
